export const ENV = {
  API_HOST: process.env.REACT_APP_DEV_API_URL,
  API_REACT_APP: process.env.REACT_APP_API_URL,
  API_FRONT: process.env.REACT_APP_API_FRONT_URL,
  KAKAO_CLIENT_REST_KEY: process.env.REACT_APP_REST_API_KEY,
  KAKAO_CLIENT_JAVASCRIPT_KEY: process.env.REACT_APP_JAVASCRIPT_API_KEY,
};
